<template>
  <section class="not-found">
    <p class="not-found__eyebrow">404</p>
    <h2>页面不存在</h2>
    <p class="not-found__desc">当前子应用中没有这个页面。</p>
    <router-link class="not-found__link" to="/">返回 Overview</router-link>
  </section>
</template>

<script>
export default {
  name: 'NotFoundView',
}
</script>

<style scoped>
.not-found {
  border: 1px solid #dbe7df;
  border-radius: 16px;
  background: #ffffff;
  padding: 1.25rem;
}

.not-found__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #2d7b5c;
  font-weight: 700;
}

.not-found h2 {
  margin: 0;
}

.not-found__desc {
  margin: 0.55rem 0 0.9rem;
  color: #52606d;
}

.not-found__link {
  display: inline-flex;
  text-decoration: none;
  color: #ffffff;
  background: #2d7b5c;
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
}
</style>
